export default "__VITE_ASSET__uKGaUIs5__"